<template>
  <v-row>
    <v-col>
      <Table
        :items="paginatedItems"
        :headers="allHeaders"
        :openDialog="openDialog"
        :showEdit="false"
        @headersUpdated="updateHeadersGrupos"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :multiple="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
      <v-row class="ma-0 pa-0" justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-pagination
            v-if="items?.length > 0"
            class="paginado ma-0 pa-0"
            v-model="currentPage"
            :length="totalPages"
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            hide-delimiter-background
            :items-per-page="limit"
            @input="changePage"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>

<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import operators from "@/store/operadores/operators";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("operators.groups"),
      titleTable: "Operadores_y_Relaciones",
      titleDelete: this.$tc("operators.deleteGroupToRelation"),
      isLoading: true,
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      currentPage: 1,
      limit: 20,
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.grupos;
    },
    items() {
      return operators.state.edit.grupos;
    },
    groups() {
      return this.$store.state.changeGroup.group.item;
    },
    groupsSelected() {
      let editGrupos = operators.state.edit.grupos;

      if (!editGrupos || editGrupos.length === 0) {
        return this.groups;
      }

      editGrupos = editGrupos.map((group) => ({
        ...group,
        groupId: group.groupId || group.grupoId,
      }));

      return this.groups.filter(
        (model) =>
          !editGrupos.some((selected) => selected.groupId === model.groupId)
      );
    },
    dataSelects() {
      return [
        {
          name: "groupId",
          label: "Grupos",
          data: "",
          items: this.groups,
          itemsValue: "groupId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },
    mode: {
      get() {
        return operators.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return operators.state.openFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return operators.state.openDelete;
      },
      set(newValue) {
        return newValue;
      },
    },
    totalPages() {
      return Math.ceil(this.items.length / this.limit);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;
      return this.items.slice(start, end);
    },
  },
  async mounted() {
    this.$store.dispatch("changeGroup/getGroups").then(() => {
      this.isLoading = false;
    });
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    async refreshItems() {
      await operators.dispatch("getOperatorId", operators.state.idOper);
    },
    updateHeadersGrupos(headers) {
      const updatedColumns = { ...configTable.state.colums, grupos: headers };
      configTable.commit("setColums", updatedColumns);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    addGroup(form) {
      const groupIds =
        typeof form.groupId === "string"
          ? form.groupId.split(",")
          : [form.groupId];
      let grupos = [];

      groupIds.forEach((id) => {
        const group = this.groups.find((group) => group.groupId == id);
        if (!group) {
          this.showAlert(`Grupo con groupId ${id} no encontrado.`, "#FF8D58");
          return;
        }
        let payload = {
          groupId: Number(id),
          nombre: group.name,
          operId: operators.state.edit.operId,
        };
        grupos.push(payload);
      });

      operators.commit("setNew", grupos);
      operators
        .dispatch("addGroupToOperator")
        .then(() => {
          this.showAlert(this.$tc("operators.addGroupSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
      this.reset(false);
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.groupsSelected;
          this.dataSelects[0].readonly = false;
          operators.commit(
            "setModeFormRelation",
            this.$tc("operators.addGroupToRelation")
          );
          operators.commit("setOpenFormRelation", true);
          break;
        case "delete":
          operators.commit("setOpenDelete", true);
          if (item.groupId) {
            item = {
              grupoId: item.groupId,
              ...item,
            };
            delete item.groupId;
          }
          this.itemToDelete = { ...item, operId: operators.state.edit.operId };
          break;
        default:
          break;
      }
    },
    reset(value) {
      operators.commit("setOpenFormRelation", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
    },
    saveForm(items) {
      if (this.typeForm === "add") {
        this.addGroup(items);
      }
    },
    deleteItem() {
      operators.commit("setItemDelete", this.itemToDelete);
      operators
        .dispatch("deleteGroupToOperator")
        .then(() => {
          this.openDelete = false;
          operators.commit("setOpenDelete", false);
          this.showAlert(this.$tc("operators.deleteGroupSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
    },
    cancelDelete() {
      this.openDelete = false;
      operators.commit("setOpenDelete", false);
    },
  },
};
</script>
